import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              India with 2.4 percent of the global land area, accounts for 7-8
              percent of the total recorded species and ranks seventh among the
              17 mega biodiversity countries of the world. A network of
              protected areas such as national parks, sanctuaries, conservation
              reserves, and community reserves has been created to purpose
              in-situ conservation under sections 18, 35, 36A, and 36C of the
              Wildlife Protection Act (1972). There are 662 Protected Areas
              (PAs) extending over 1,58,508 km<sup>2</sup> (4.83% of the total
              geographic area), comprising 103 National Parks, 514 Wildlife
              Sanctuaries, 44 Conservation Reserves, and 4 Community Reserves.
              39 Tiger Reserves and 28 Elephant Reserves have been designated
              for species specific management of tiger and elephant habitats.
              However, globalisation and the opening up of Indian markets during
              the nineties have led to large-scale land cover changes.
              Conservation and management endeavor is currently facing numerous
              challenges such as habitat loss due to forest fragmentations,
              conversion of forests to monoculture plantations, overuse of
              biomass resources due to the biotic pressures, increasing
              human-wildlife conflicts, poaching, and illegal trade, etc. The
              accelerated anthropogenic pressure with the unplanned
              developmental activities have triggered changes in the ecosystem
              function evident from barren hilltops, conversion of perennial
              streams to seasonal streams, lowered pollination services, etc.
              due to the changes in ecosystem integrity and impacting the
              ecology, biodiversity, nutrient cycling, socio-economic systems
              (Brooks et al., 2002; Haddad et al., 2015; Ramachandra et al.,
              2016, 2017, 2018a).
            </p>
            <p>
              Decision-making pertaining to natural resources has been a
              challenging task due to the requirement of complex data and the
              need for more transparency of decision processes to participate in
              the process. To enhance the individual or group of person&rsquo;s
              ability to make decisions and support decision-making activities
              necessitates the design of Decision Support Systems (DSS) to
              support decision-making activities towards prudent management of
              natural resources. Spatial decision support systems (SDSS) have
              evolved over the last few decades, taking advantage of advances in
              spatial and communication technologies to integrate
              location-specific data (spatial data). SDSS combines analytical
              tools with functions available in GIS (Geographic Information
              System) as well as models for geo-visualising likely scenarios
              associated with the decisions.
            </p>
            <p>
              SDSS is an integrated spatial database management system with
              spatial and attribute database, analytical and operational
              research models, visualisation options, reporting capabilities and
              the expert knowledge of decision-makers to assist in prudent
              management of ecosystem resources and solving specific problems in
              a simple and effective manner (Crossland et al., 1995; Sugumaran
              and Degroote, 2010; Ferretti and Montibeller, 2016). SDSS offers
              insights into the structure of spatial decision problems by
              helping decision makers to frame alternatives and strategies in a
              problem-solving process (Matthies et al., 2007). Recent advances
              in geo-informatics, the internet, information technology, and the
              availability of spatial data have led to effective knowledge
              dissemination. Free and Open Source Software (FOSS) with the
              availability of multi-resolution spatial data has helped in
              capturing the landscape dynamics and lending a platform to assess
              climate change, water resources, urban development, natural
              disaster mitigation, etc. (Ramachandra and Kumar, 2008; Steiniger
              and Hay, 2009; Bharath et al., 2012).
            </p>
            <p>
              Globally, PA networks or conservation areas have been proved to be
              the most effective means of conservation to arrest the detrimental
              effect of anthropogenic impacts (Gray et al., 2016; Ramachandra et
              al., 2018b). Conservation through appropriate conservation
              framework has been regarded globally as a key strategy to address
              the growing extinction crisis (Jenkins and Joppa, 2009).
              &nbsp;Change analyses through temporal remote sensing data have
              confirmed that the PAs have been successful in controlling the
              rapid land use changes (Nelson and Chomitz, 2011), successfully
              maintaining the integrity of forest ecosystem, regulating the loss
              of carbon sequestering capabilities (Nolte et al., 2013) and
              mitigating instances of forest fires (Joppa and Pfaff, 2011). PAs
              networks are final refuges for threatened species, natural
              ecosystem processes, and a positive effect on species richness and
              abundance, evident from the review of 86 case studies
              (Coetzee&nbsp;et al., 2014) and are aiding as a cornerstone to
              conserve tropical biodiversity despite burgeoning anthropogenic
              stresses. These measures, solely regulatory with the
              organizational and political difficulties, are associated with
              imposing and enforcing restrictions over a broad range of
              detrimental human activities (Kiesecker et al., 2015).
              Unfortunately, still the fragmentation of forests, human
              encroachment, mismanagement and other environmental stresses
              within PAs are imperiling biodiversity (Laurance et al., 2012).
              This necessitates assessing current status, landscape dynamics
              within PAs, ecology, management, and enrichment, which remains a
              critical knowledge gap due to the lack of comprehensive data and
              appropriate conservation approaches (Green et al., 2015). The
              present endeavor develops an interactive Spatial Decision Support
              System for sustainable management of protected areas in Karnataka
              (KPASDSS) by taking advantage of the latest advancements in
              geo-informatics with the integration of spatial and attributes
              information from disparate sources. Visualizing the scenario
              associated with the proposed decisions help the decision-makers to
              acquire a holistic view for policy synthesis. Geo-visualization
              through the interactive decision maps with the assigned target
              criteria levels and information about potentially feasible
              combinations of attribute data. This allows decision-makers to
              gain insights of the respective region&rsquo;s ecological,
              economic, and social interactions, which helps in generating the
              information required for developing ecologically sound policies.
              &nbsp;This helps in (i) the prudent governance of PAs while
              enhancing the transparency and meeting the societal needs, and
              (ii) visualisation of landscape dynamics with the integration of
              attribute information enables understanding the current status and
              predicting likely changes, which are quintessential for
              sustainable management of natural resources.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
